"use client";

import { api } from "@/lib/trpc/react";

/** Hours plotted, and the window the panel labels itself with. */
export const SITTING_WINDOW_HOURS = 12;

/**
 * How often activity is re-read while the page is open.
 *
 * Fifteen seconds is short enough that the figures are current when somebody
 * looks at them, and long enough that a page left open on a second monitor costs
 * little. Polling is all this buys: how close "sitting now" is to the truth is
 * set by the staleness window in `getExamSittingActivity`, not by this interval,
 * because nothing closes an attempt that was opened and walked away from.
 */
const POLL_MS = 15_000;

/**
 * Live sitting activity for one exam.
 *
 * Both halves of the hero read this: the panel plots the series, and the band
 * beside it prints the outcome counts. They share one query key, so React Query
 * serves both from a single request and a tick updates them in the same commit
 * rather than leaving one a frame behind the other.
 */
export function useSittingActivity(slug: string) {
  return api.assessments.sittingActivity.useQuery(
    { slug, hours: SITTING_WINDOW_HOURS },
    {
      refetchInterval: POLL_MS,
      // Only while the tab is in front; `refetchInterval` alone keeps firing on
      // a backgrounded tab.
      refetchIntervalInBackground: false,
      refetchOnWindowFocus: true,
      // Hold the last reading through a refetch, so the panel does not empty for
      // a frame on every tick.
      placeholderData: (previous) => previous,
    },
  );
}
